export default {
  data: null
};
